<template>
<div class="view-leaps-action-overlay">
   <div class="container-fluid">
      <div id="myNav" class="overlay overlay-overall-width-100Perc">
          <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc">
              <div class="row">
                <div class="col-md-12 col-lg-12">
                  <div class="text-right close-text-font-style margin-right-2Perc margin-top-2Perc cursor-pointer" @click="updateHideViewLeapsActionOverlayFlag($event)">
                    <img src= "../../../assets/images/close.svg" class="img-responsive close-img-width-height margin-top-3Perc float-right" alt="close-icon">
                  </div>  
                </div>
              </div>

              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
                  <b>Title:</b>
                </div>
                <div class="col-md-3 col-lg-3 create-lesson-input-text-style text-align-left padding-left-0Px">
                  {{objToPass.ActionName}}
                </div>
                <div class="col-md-2 col-lg-2 text-align-right create-lesson-input-text-style">
                    <b>Course:</b>
                </div>
                <div class="col-md-3 col-lg-3 text-align-left create-lesson-input-text-style">
                  {{getCourseName(objToPass.CourseMasterId)}}
                </div>
                <div class="col-md-1 col-lg-1"></div>
              </div>

              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
                  <b>Is Active:</b>
                </div>
                <div class="col-md-3 col-lg-3 create-lesson-input-text-style text-align-left padding-left-0Px">
                  {{objToPass.IsActive ? 'Yes' : 'No'}}
                </div>
                <div class="col-md-2 col-lg-2 text-align-right create-lesson-input-text-style">
                    <b>Version:</b>
                </div>
                <div class="col-md-3 col-lg-3 text-align-left create-lesson-input-text-style" :class="{'text-color-red' : objToPass.ActionVersion === 'Not Found.'}">
                  {{objToPass.ActionVersion}}
                </div>
                <div class="col-md-1 col-lg-1"></div>
              </div>
            
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
                  <b>Attached Energy:</b>
                </div>
                <div class="col-md-3 col-lg-3 create-lesson-input-text-style text-align-left padding-left-0Px">
                  <div v-for="(energyObj, index) in selectedEnergyValues" :key="index">
                  {{ energyObj.name}}
                  </div>
                  <div class="text-color-red" v-if="selectedEnergyValues.length === 0">
                    Not Found.
                  </div>
                </div>
                <div class="col-md-2 col-lg-2 text-align-right create-lesson-input-text-style">
                    <b>Attached Affirmations:</b>
                </div>
                <div class="col-md-3 col-lg-3 text-align-left create-lesson-input-text-style">
                  <div v-for="(affirmationObj, index) in selectedAffirmationValues" :key="index">
                    {{(index + 1) + ') ' + affirmationObj.name}}
                  </div>
                  <div class="text-color-red" v-if="selectedAffirmationValues.length === 0">
                    Not Found.
                  </div>
                </div>
                <div class="col-md-1 col-lg-1"></div>
              </div>
            
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
                  <b>Toolkit Url:</b>
                </div>
                <div class="col-md-3 col-lg-3 create-lesson-input-text-style text-align-left padding-left-0Px">
                  <div v-if="objToPass.ActionToolkit !== undefined && objToPass.ActionToolkit !== 'undefined' && objToPass.ActionToolkit !== null && objToPass.ActionToolkit !== 'null' && objToPass.ActionToolkit !== ''">
                    <a target="_blank" class="text-color-blue" :href="objToPass.ActionToolkit"><u>Download File</u></a>
                  </div>
                  <div class="text-color-red" v-else>
                    Not Found.
                  </div>
                </div>
                <div class="col-md-2 col-lg-2 text-align-right create-lesson-input-text-style">
                  <b>Attached Meditations:</b>
                </div>
                <div class="col-md-3 col-lg-3 text-align-left create-lesson-input-text-style">
                  <div v-for="(meditationObj, index) in selectedMeditationValues" :key="index">
                    {{(index + 1) + ') ' + meditationObj.name}}
                  </div>
                  <div class="text-color-red" v-if="selectedMeditationValues.length === 0">
                    Not Found.
                  </div>
                </div>
                <div class="col-md-1 col-lg-1"></div>
              </div>

              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
                  <b>Created TS:</b>
                </div>
                <div class="col-md-3 col-lg-3 create-lesson-input-text-style text-align-left padding-left-0Px">
                  {{objToPass.CreatedTS}}
                </div>
                <div class="col-md-2 col-lg-2 text-align-right create-lesson-input-text-style">
                    <b>Updated TS:</b>
                </div>
                <div class="col-md-3 col-lg-3 text-align-left create-lesson-input-text-style">
                  {{objToPass.UpdatedTS}}
                </div>
                <div class="col-md-1 col-lg-1"></div>
              </div>
          
              <div class="row margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
                  <b>Introduction:</b>
                </div>
                <div class="col-md-8 col-lg-8 padding-left-0Px text-align-left create-lesson-input-text-style">
                  <span v-html="objToPass.ActionIntro"></span>
                </div>
                <div class="col-md-1 col-lg-1"></div>  
              </div>
              
              <div class="row margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
                  <b>Short Description:</b>
                </div>
                <div class="col-md-8 col-lg-8 padding-left-0Px text-align-left create-lesson-input-text-style">
                  <span v-html="objToPass.ActionDetail"></span>
                </div>
                <div class="col-md-1 col-lg-1"></div>  
              </div>

              <div class="row margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
                  <b>Long Description:</b>
                </div>
                <div class="col-md-8 col-lg-8 padding-left-0Px text-align-left create-lesson-input-text-style">
                  <span v-html="objToPass.ActionDescription"></span>
                </div>
                <div class="col-md-1 col-lg-1"></div>  
              </div>
              
              <div class="row margin-bottom-2Perc">
                <div class="col-md-5 col-lg-5">
                </div>  
                <div class="col-md-2 col-lg-2">
                  <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color" @click="updateHideViewLeapsActionOverlayFlag($event)">Close</button>
                </div>  
                <div class="col-md-5 col-lg-5">
                </div>
              </div>
              <div class="row">
              </div>         
          </div>
      </div>
 </div>
 </div>
</template>

<script>
import { constants } from '@/utils/constants'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
import find from 'lodash/find'
import filter from 'lodash/filter'
import findIndex from 'lodash/findIndex'
import { forEach } from 'lodash'
import { leapsEnergyService } from '@/server-util/leaps-energy-service'
import { leapsAffirmationService } from '@/server-util/leaps-affirmation-service'
import { courseService } from '@/server-util/course-service'
import { leapsMeditationService } from '@/server-util/leaps-meditation-service'
export default {
  props: ['currSelectedObj'],
  created: function () {
    this.getLeapsEnergyList()
    this.setDefaultValues()
  },
  data: function () {
    return {
      constants: constants,
      objToPass: {
        ActionLibraryId: '',
        ActionVersion: '',
        ActionName: '',
        ActionDescription: '',
        ActionIntro: '',
        CreatedTS: '',
        UpdatedTS: '',
        ActionDetail: '',
        IsActive: false,
        CourseMasterId: '',
        ActionToolkit: ''
      },
      selectedAffirmationValues: [],
      selectedEnergyValues: [],
      selectedMeditationValues: []
    }
  },
  name: 'view-leaps-action-overlay',
  methods: {
    getLeapsEnergyList: function () {
      var storeObj = this.$store
      if (
        storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== ''
      ) {
        // AK: Check weather leapsEnergyList is already present or not?
        if (storeObj.state.leapsEnergyList.length === 0) {
          this.$store.state.isLoading = true
        }
        leapsEnergyService
          .getLeapsEnergyList(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.leapsEnergyList = responseObj.data
              if (this.$store.state.isLoading === true) {
                this.$store.state.isLoading = false
              }
              this.getLeapsAffirmationList()
            } else {
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token is NULL hence declined LOADING LEAPS ENGERY LIST'
        )
      }
    },
    getLeapsAffirmationList: function () {
      var storeObj = this.$store
      if (
        storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== ''
      ) {
        // AK: Check weather leapsEnergyList is already present or not?
        if (storeObj.state.leapsAffirmationList.length === 0) {
          this.$store.state.isLoading = true
        } else {
          this.setDefaultValues()
          this.getCourses()
        }
        leapsAffirmationService
          .getLeapsAffirmationList(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.leapsAffirmationList = responseObj.data
              if (this.$store.state.isLoading === true) {
                this.$store.state.isLoading = false
                this.getCourses()
              }
              this.setDefaultValues()
            } else {
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token is NULL hence declined LOADING LEAPS AFFIRMATION LIST'
        )
      }
    },
    getCourses: function () {
      var storeObj = this.$store
      if (storeObj.state.access_token !== undefined && storeObj.state.access_token !== '' && storeObj.state.access_token !== null) {
        // AK: Check weather Course List is already present on not
        if (storeObj.state.course_list.length === 0) {
          this.$store.state.isLoading = true
        }

        courseService.listCourses(storeObj.state.access_token)
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              storeObj.state.course_list = responseObj.data
              this.$store.state.isLoading = false
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              this.$store.state.isLoading = false
            }
          }, errorObj => {
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
            this.$store.state.isLoading = false
          })
      } else {
        console.log('ACCESS TOKEN IS NOT FOUND HENCE DECLINE GET COURSE LIST OPERATION')
      }
    },
    getCourseName: function (courseMasterId) {
      var nameToReturn = ''
      if (courseMasterId !== undefined && courseMasterId !== null && courseMasterId !== 'null' && courseMasterId !== constants.Default_Assessment_Module_Id_Guid) {
        const courseObj = find(this.getCourseList, (obj) => {
          return obj.CourseMasterId === courseMasterId
        })
        if (courseObj !== undefined && courseObj !== null) {
          if (courseObj.CourseTitle !== undefined && courseObj.CourseTitle !== 'undefined' && courseObj.CourseTitle !== null && courseObj.CourseTitle !== 'null' && courseObj.CourseTitle !== '') {
            nameToReturn = courseObj.CourseTitle
          }
          if (courseObj.SubTitle !== undefined && courseObj.SubTitle !== 'undefined' && courseObj.SubTitle !== null && courseObj.SubTitle !== 'null' && courseObj.SubTitle !== '') {
            nameToReturn += ' [' + courseObj.SubTitle + ']'
          }
        } else {
          nameToReturn = 'Not Found.'
        }
      } else {
        nameToReturn = 'Not Found.'
      }
      return nameToReturn
    },
    bindAffirmationList: function (actionAffirmations) {
      var arrToReturn = []
      forEach(actionAffirmations, (affirmationLibraryId) => {
        const foundObj = find(this.$store.state.leapsAffirmationList, (obj) => {
          return affirmationLibraryId === obj.AffirmationLibraryId
        })
        if (foundObj !== undefined && foundObj !== 'undefined' && foundObj !== null && foundObj !== 'null' && foundObj !== '') {
          var objToPush = {
            name: foundObj.AffirmationTitle,
            affirmationlibraryid: foundObj.AffirmationLibraryId
          }
          arrToReturn.push(objToPush)
        }
      })
      return arrToReturn
    },
    getLeapsMeditationListFromServer: function (actionMeditations) {
      var storeObj = this.$store
      var reloadMeditationList = false
      if (
        storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== ''
      ) {
        if (storeObj.state.leapsMeditationList.length === 0) {
          this.$store.state.isLoading = true
          reloadMeditationList = true
        }
        leapsMeditationService
          .getLeapsMeditationList(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              storeObj.state.leapsMeditationList = responseObj.data
              if (this.$store.state.isLoading === true) {
                this.$store.state.isLoading = false
              }
              if (reloadMeditationList) {
                this.selectedMeditationValues = this.currSelectedObj.ActionMeditations !== undefined && this.currSelectedObj.ActionMeditations !== 'undefined' && this.currSelectedObj.ActionMeditations !== null && this.currSelectedObj.ActionMeditations !== 'null' && this.currSelectedObj.ActionMeditations !== '' ? this.bindMeditationList(actionMeditations) : []
              }
            } else {
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token is NULL hence declined LOADING LEAPS MEDITATION LIST'
        )
      }
    },
    bindMeditationList: function (actionMeditations) {
      var arrToReturn = []
      if (this.$store.state.leapsMeditationList !== undefined && this.$store.state.leapsMeditationList !== 'undefined' && this.$store.state.leapsMeditationList !== null && this.$store.state.leapsMeditationList !== 'null' && this.$store.state.leapsMeditationList !== '' && this.$store.state.leapsMeditationList.length !== 0) {
        forEach(actionMeditations, (meditationLibraryId) => {
          const foundObj = find(this.$store.state.leapsMeditationList, (obj) => {
            return meditationLibraryId === obj.MeditationLibraryId
          })
          if (foundObj !== undefined && foundObj !== 'undefined' && foundObj !== null && foundObj !== 'null' && foundObj !== '') {
            const foundInde = findIndex(arrToReturn, (obj) => {
              return obj.meditationLibraryId === foundObj.MeditationLibraryId
            })
            if (foundInde === -1) {
              var objToPush = {
                name: foundObj.MeditationTitle,
                meditationLibraryId: foundObj.MeditationLibraryId
              }
              arrToReturn.push(objToPush)
            }
          }
        })
      } else {
        this.getLeapsMeditationListFromServer(actionMeditations)
      }
      return arrToReturn
    },
    bindEnergyList: function (actionEngeries) {
      var arrToReturn = []
      forEach(actionEngeries, (energyId) => {
        const foundObj = find(this.$store.state.leapsEnergyList, (obj) => {
          return energyId === obj.EnergyId
        })
        if (foundObj !== undefined && foundObj !== 'undefined' && foundObj !== null && foundObj !== 'null' && foundObj !== '') {
          var objToPush = {
            name: foundObj.EnergyTitle,
            energyid: foundObj.EnergyId
          }
          arrToReturn.push(objToPush)
        }
      })
      return arrToReturn
    },
    setDefaultValues: function () {
      this.objToPass.ActionToolkit = this.currSelectedObj.ActionToolkit
      this.objToPass.CourseMasterId = this.currSelectedObj.CourseMasterId
      this.objToPass.ActionLibraryId = this.currSelectedObj.ActionLibraryId
      this.objToPass.ActionName = this.currSelectedObj.ActionName
      this.objToPass.ActionIntro = this.currSelectedObj.ActionIntro
      this.objToPass.ActionDetail = this.currSelectedObj.ActionDetail
      this.objToPass.CreatedTS = this.currSelectedObj.CreatedTS
      this.objToPass.IsActive = this.currSelectedObj.IsActive
      this.selectedAffirmationValues = this.currSelectedObj.ActionAffirmations !== undefined && this.currSelectedObj.ActionAffirmations !== 'undefined' && this.currSelectedObj.ActionAffirmations !== null && this.currSelectedObj.ActionAffirmations !== 'null' && this.currSelectedObj.ActionAffirmations !== '' ? this.bindAffirmationList(JSON.parse(this.currSelectedObj.ActionAffirmations)) : []
      this.selectedMeditationValues = this.currSelectedObj.ActionMeditations !== undefined && this.currSelectedObj.ActionMeditations !== 'undefined' && this.currSelectedObj.ActionMeditations !== null && this.currSelectedObj.ActionMeditations !== 'null' && this.currSelectedObj.ActionMeditations !== '' ? this.bindMeditationList(JSON.parse(this.currSelectedObj.ActionMeditations)) : []
      this.selectedEnergyValues = this.currSelectedObj.ActionEnergies !== undefined && this.currSelectedObj.ActionEnergies !== 'undefined' && this.currSelectedObj.ActionEnergies !== null && this.currSelectedObj.ActionEnergies !== 'null' && this.currSelectedObj.ActionEnergies !== '' ? this.bindEnergyList(JSON.parse(this.currSelectedObj.ActionEnergies)) : []
      this.objToPass.ActionVersion = (this.currSelectedObj.ActionVersion !== undefined && this.currSelectedObj.ActionVersion !== 'undefined' && this.currSelectedObj.ActionVersion !== null && this.currSelectedObj.ActionVersion !== 'null' && this.currSelectedObj.ActionVersion !== '' && this.currSelectedObj.ActionVersion.trim().length !== 0) ? this.currSelectedObj.ActionVersion : 'Not Found.'
      if (this.objToPass.CreatedTS.indexOf('Z') === -1) {
        this.objToPass.CreatedTS += 'Z'
      }
      this.objToPass.CreatedTS = dmAdminUtils.covertUtcToEst(this.objToPass.CreatedTS)
      this.objToPass.UpdatedTS = this.currSelectedObj.UpdatedTS
      if (this.objToPass.UpdatedTS.indexOf('Z') === -1) {
        this.objToPass.UpdatedTS += 'Z'
      }
      this.objToPass.UpdatedTS = dmAdminUtils.covertUtcToEst(this.objToPass.UpdatedTS)
      this.objToPass.ActionDescription = this.currSelectedObj.ActionDescription
    },
    updateHideViewLeapsActionOverlayFlag: function (event) {
      var objToReturn = {
        closeOverlay: true,
        createdObj: null
      }
      this.$emit('emittedValue', objToReturn)
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    }
  },
  components: {},
  computed: {
    getCourseList: {
      get: function () {
        return filter(this.getGlobalCourseList, (obj) => {
          return obj.Type !== constants.CourseType.RecommendationAssessment
        })
      }
    },
    getGlobalCourseList: {
      get: function () {
        return this.$store.state.course_list
      }
    }
  }
}
</script>

<style scoped>
.text-color-red {
  color: red !important;
}
.text-color-blue {
  color: blue !important;
}
.audio-width {
  width: -webkit-fill-available;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.red{
  background-color: red;
}
.MainDiv
{
  overflow-y: hidden !important;
}
.margin-Top-0Perc{
  margin-top: 0%;
}
.margin-Top-1Perc{
  margin-top: 1%;
}
.margin-Top-2Perc
{
	margin-top: 2%;
}
.margin-Top-3Perc
{
	margin-top: 3%;
}
.margin-Top-8Perc
{
	margin-top: 8%;
}
.margin-bottom-0Perc
{
	margin-bottom: 0%;
}
.margin-bottom-2Perc
{
	margin-bottom: 2%;
}
.margin-left-0Perc
{
    margin-left:0%;
}
.margin-left-1Perc
{
    margin-left:2%;
}
.margin-left-2Perc
{
    margin-left:2%;
}
.margin-left-3Perc{
  margin-left:3%;
}
.margin-left-4Perc
{
    margin-left:4%;
}
.margin-left-5Perc{
  margin-left:5%;
}
.margin-left-6Perc{
  margin-left:6%
}
.margin-left-9Perc
{
    margin-left:9%;
}
.padding-Left-0px
{
  padding-left: 0px !important;
}
.padding-Left-30px
{
  padding-left: 3% !important;
}
.text-align-center
{
  text-align: center;
}
.left-border
{
  border-left: 1px solid #aaa;
}

.background-color-red
{
	background-color: red;
}
.cf-border
{
	border:1px solid black;
}
.text-align-left
{
  text-align: left;
}
.font-size-1-3vw
{
  font-size: 1.3vw;
}
.font-size-20px
{
  font-size: 20px;
}
.background-gray{
  background-color: #ddd;

}

.border-rounded{
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}

  .overflow-x-hidden{
    overflow-x: hidden !important;
  }
  .font-size-18px {
  font-size: 18px;
}
.gray-border {
  border: 1px solid #aaa;
}
.white-BG {
  background-color: #ffffff;
}
.width-70Perc {
  width: 70%;
}
.width-90Perc {
  width: 90%;
}
.margin-auto{
margin: auto;
}
.margin-bottom-0px {
  margin-bottom: 0px !important;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-content {
  position: relative;
  top: 7%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.center-aligned-div {
  margin: 0 auto;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.background-color-white {
  background-color: #ffffff !important;
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.margin-top-2Perc {
  margin-top: 2%;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.float-right {
  float: right;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 17px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
.padding-left-0Px {
  padding-left: 0px !important;
}
switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.text-align-right {
  text-align: right;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color
{
  color: #000 !important;
}
.opacity0Point5 {
  opacity: 0.5;
}
.orangeColor {
  color: #f39c12;
}
.margin-right-15px {
  margin-right: 15px;
}
</style>





// WEBPACK FOOTER //
// src/components/leaps/action/ViewLeapsActionOverlay.vue